import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5457_9804)">
      <path
        d="M12.5 0.758057C5.87704 0.758057 0.5 6.1351 0.5 12.758C0.5 19.381 5.87704 24.758 12.5 24.758C19.1229 24.758 24.5 19.381 24.5 12.758C24.5164 6.1351 19.1393 0.758057 12.5 0.758057ZM17.7787 14.2826H14.3852V15.5613C14.3852 18.1351 12.3033 20.217 9.72949 20.217C7.15573 20.217 5.07376 18.1351 5.07376 15.5613C5.07376 12.9875 7.15573 10.9056 9.72949 10.9056H10.9918V14.299H14.3852V10.8892H17.7787V14.2826ZM19.4672 9.18427H15.6475C14.9426 9.18427 14.3852 9.75804 14.3688 10.463V10.8892H10.9918V10.463C10.9918 7.88919 13.0738 5.80723 15.6475 5.80723H19.4672V9.18427Z"
        fill="#FBFCFD"
      />
      <path
        d="M9.71301 14.2827C9.0081 14.2827 8.43433 14.8565 8.43433 15.5614C8.43433 16.2663 9.0081 16.8401 9.71301 16.8401C10.4179 16.8401 10.9917 16.2663 10.9917 15.5614V14.2827H9.71301C9.71301 14.2663 9.71301 14.2663 9.71301 14.2827Z"
        fill="#FBFCFD"
      />
    </g>
    <defs>
      <clipPath id="clip0_5457_9804">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0.5 0.758057)"
        />
      </clipPath>
    </defs>
  </svg>
)
